import '../styles/main.css'
import '@/lib/select.js'
import lazim from 'lazim'
import app from '@/app.js'
import { fetchCart } from '@/lib/cart.js'
require("babel-core/register")
require("babel-polyfill")
import AOS from 'aos';

window.addEventListener('load', () => {
  setTimeout(function() {
    document.body.classList.add('loaded')

    AOS.init()

  }, 300)
})

window.scrollTo(0, 0)


/**
 * load any data that your site needs on fist load
 */
Promise.all([
  fetchCart()
]).then(([ cart ]) => {
  /**
   * add the cart data to the picoapp instance
   */
  app.hydrate({ cart })

  /**
   * mount any components defined on the page
   */
  app.mount()
})
